import clsx from "clsx";
import * as React from "react";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<>
				<input
					type={type}
					spellCheck={false}
					className={clsx(
						"block w-full",
						{
							"bg-muted text-muted-foreground": props.disabled,
							"bg-background text-foreground": !props.disabled,
						},
						className,
					)}
					ref={ref}
					{...props}
				/>
			</>
		);
	},
);
Input.displayName = "Input";

export { Input };
